<template>
  <ul class="navbar-nav">
    <template
      v-for="r in routes"
      :key="r.path"
    >
      <li
        class="nav-item dropdown"
        v-if="r.children?.length"
        v-dropdown
      >
        <RouterLink
          :to="r"
          class="nav-link dropdown-toggle"
        >
          {{ r.meta.title }}
        </RouterLink>
        <ul class="dropdown-menu">
          <template v-for="c of r.children">
            <RouterLink
              :to="c"
              v-slot="{ href, navigate, isActive }"
            >
              <li
                class="dropdown-item"
                :class="{ active: isActive }"
              >
                <a
                  :href="href"
                  @click="navigate"
                  >{{ c.meta.title }}</a
                >
              </li>
            </RouterLink>
          </template>
        </ul>
      </li>
      <li
        class="nav-item"
        v-else
      >
        <RouterLink
          :to="r"
          class="nav-link"
        >
          {{ r.meta.title }}
        </RouterLink>
      </li>
    </template>
  </ul>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useUserStore } from '@provise/stores/user'
import { computed } from 'vue'

const router = useRouter()
const userStore = useUserStore()
const routes = computed(() => {
  let rts = router.options.routes
  return filtroutes(rts)
})

function filtroutes(rts) {
  let res = []

  for (const r of rts) {
    let visible = r.meta?.navbar
    let children = filtroutes(r.children || [])

    if (visible && r.meta?.rbac) {
      visible = userStore.can(r.meta.rbac)
    }

    if (!visible) {
      continue
    }

    if (!r.children?.length) {
      res.push(r)
      continue
    }

    if (children.length) {
      r.children = children
      res.push(r)
    }
  }
  return res
}
</script>
